const DESA = `http://localhost:8080/experto`;
const PROD = `https://tmc.desarrollosedetc.com/experto`;

const AUTH_DESA = 'http://localhost:3000';
const AUTH_PRD = 'https://experto.sedetc.gob.pe';

const ENV = PROD;
const ENV_AUTH = AUTH_PRD;

export const REST_API_PUBLIC = ENV +`/public`;
export const REST_API_PRIVATE = ENV +`/private`;
export const AUTH_API = ENV_AUTH;